import { CustomerType } from '@npco/mp-utils-logged-in-user'

export const getUserDisplayName = (userData?: CustomerType | null) => {
  if (!userData) {
    return ''
  }

  return [userData?.firstname, userData?.lastname].filter(Boolean).join(' ')
}
